import { styled } from "goober";
import type { ReactNode } from "react";
import { Icon } from "../Icon";
import { PressButton } from "../PressButton";
import { DetailLabel, IconBadge, ListBox } from "../Settings/shared";
import { Text } from "../Text";

export const ChatpadBody = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 8px;

  &[data-fill="true"] {
    height: 100%;
    min-height: 0;
    gap: 0;
    padding: 0;
  }
`;

export const ChatpadList = styled(ListBox)`
  flex: none;
  overflow: hidden;

  &[data-fill="true"] {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    background: var(--surface-secondary);
    border: none;
    border-radius: 0;

    &:not(:first-child) {
      border-top: 0.5px solid var(--border-alpha);
    }
  }
`;

export const ChatpadListScrollArea = styled("div")`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
`;

export const ChatpadListHeader = styled("div")`
  display: flex;
  align-items: center;
  gap: 4px;
  height: 40px;
  flex-shrink: 0;
  padding: 8px;
  border-bottom: 0.5px solid var(--border-alpha);
`;

const Row = styled(PressButton)`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-height: 64px;
  padding: 12px 16px;
  text-align: left;
  cursor: pointer;
  &:not(:last-child) {
    border-bottom: 0.5px solid var(--border-alpha);
  }
  &:hover {
    background: var(--surface-hover);
  }
  &:focus-visible {
    outline: 2px solid var(--focus-ring);
    outline-offset: -2px;
  }
`;

export const ChatpadListBadge = styled(IconBadge)`
  background: var(--alpha4);
  color: var(--text-primary);
`;

const ChatpadListText = styled(DetailLabel)`
  align-items: flex-start;
  flex: 1;
  overflow-wrap: anywhere;
`;

export function ChatpadListRow({
  badge,
  title,
  description,
  onPress,
  "aria-label": ariaLabel = title,
}: {
  badge: ReactNode;
  title: string;
  description?: string;
  onPress: () => void;
  "aria-label"?: string;
}) {
  return (
    <Row
      data-no-pill
      onPress={onPress}
      aria-label={ariaLabel}
      aria-description={description}
    >
      {badge}
      <ChatpadListText>
        <Text variant="text-regular-md">{title}</Text>
        {description && (
          <Text variant="text-small" color="var(--text-secondary)">
            {description}
          </Text>
        )}
      </ChatpadListText>
      <Icon name="chevron-right" size={12} color="var(--text-secondary)" />
    </Row>
  );
}
